import React from 'react'

const Heading = ({children}) => (
  <h1 className="text-3xl my-10 text-bhd-pink font-bold">{children}</h1>
)

export default Heading;


